import { createFileRoute, Outlet } from "@tanstack/react-router";

// Thin wrapper for the per-farm livestock routes. The old farm-level tab bar
// (Overview / Herds / Animals / Measurements / Operations / Registros) was
// removed: browsing now lives on the scope-aware hub (/livestock), and every
// child page here owns its own breadcrumb + back nav. Kept as a layout so the
// index/registries redirects and the herds/animals sub-routes resolve under
// one segment.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/livestock/$establishmentId",
)({
	staticData: { offline: "ready" },
	component: () => <Outlet />,
});
